import React from "react";
import Dashboard from "./Dashboard";
import "./OfficerDashboard.css";

function OfficerDashboard() {
  return (
    <div className="officer-dashboard-container">
      <div className="container">
        <h1>👮 Officer Dashboard </h1>
        <p className="dashboard-subtitle">
          View resident and account details (Read-Only Access).
        </p>
        
        {/* Reuse AdminDashboard with read-only mode */}
        <Dashboard readOnly={true} />
      </div>
    </div>
  );
}

export default OfficerDashboard;